import { render, staticRenderFns } from "./ClinicServicesGroupsTab.vue?vue&type=template&id=7193cc9e&scoped=true"
import script from "./ClinicServicesGroupsTab.vue?vue&type=script&lang=js"
export * from "./ClinicServicesGroupsTab.vue?vue&type=script&lang=js"
import style0 from "./ClinicServicesGroupsTab.vue?vue&type=style&index=0&id=7193cc9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7193cc9e",
  null
  
)

export default component.exports